import Skeleton from "react-loading-skeleton";
import React, { JSX, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useGetNotificationsQuery } from "../../../../common/api/notification";
import { NotificationInterface } from "../../../../common/interfaces/NotificationInterface";
import { NotificationItem } from "../general/NotificationItem";
import {
    setIsAtQualification,
    setIsCreateCertificateModalOpen,
    setSelectedEmployee,
    setSelectedQualification,
} from "../../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { setCurrentPage, setItemsPerPage } from "../../NotificationsSlice";
import { SecondaryPagination } from "@hatch-digital-nl/abs-storybook/legacy";
import { useEmployeeId } from "../../../../common/utils/useEmployeeId";
import {
    setApproved,
    setIsEditCertificateModalOpen,
    setSelectedCertificateId,
} from "../../../../modals/EditCertificateModal/EditCertificateModalSlice";

export const EmployeeNotifications = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const { itemsPerPage, itemsPerPageSelect, currentPage } = useAppSelector(
        (state) => state.notifications,
    );
    const { isPostCreateCertificateSuccess } = useAppSelector(
        (state) => state.createCertificateModal,
    );
    const {
        isPatchEditCertificateSuccess,
        isOpenFormLoading,
        selectedCertificateId,
    } = useAppSelector((state) => state.editCertificateModal);

    const {
        data: employeeNotificationsData,
        isLoading: employeeNotificationsIsLoading,
        isFetching: employeeNotificationsIsFetching,
        refetch: refetchEstablishmentNotifications,
    } = useGetNotificationsQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        filter: {
            employee_id: useEmployeeId(),
        },
    });

    useEffect(() => {
        if (isPostCreateCertificateSuccess || isPatchEditCertificateSuccess) {
            refetchEstablishmentNotifications();
        }
    }, [
        isPostCreateCertificateSuccess,
        isPatchEditCertificateSuccess,
        refetchEstablishmentNotifications,
    ]);

    if (employeeNotificationsIsLoading || employeeNotificationsIsFetching) {
        return <Skeleton height={"9rem"} count={8} borderRadius={"1.5rem"} />;
    }

    if (!employeeNotificationsData) {
        return null;
    }
    return (
        <section className={"p-notifications__content"}>
            {employeeNotificationsData.data.map(
                (notification: NotificationInterface, index: number) => (
                    <NotificationItem
                        key={index}
                        notification={notification}
                        onClick={() => {
                            if (notification.certificate?.approved === false) {
                                dispatch(setApproved(null));
                                dispatch(
                                    setSelectedCertificateId(
                                        notification.certificate?.id,
                                    ),
                                );
                                dispatch(setIsEditCertificateModalOpen(true));
                                return;
                            }

                            dispatch(setIsAtQualification(false));
                            dispatch(
                                setSelectedEmployee(notification.employee),
                            );
                            dispatch(
                                setSelectedQualification(
                                    notification.qualification,
                                ),
                            );
                            dispatch(setIsCreateCertificateModalOpen(true));
                        }}
                        isLoading={
                            isOpenFormLoading &&
                            selectedCertificateId ===
                                notification.certificate?.id
                        }
                    />
                ),
            )}
            <SecondaryPagination
                itemsPerPage={itemsPerPage}
                totalItems={employeeNotificationsData?.meta?.total || 0}
                currentPage={currentPage}
                onPaginationChange={(page: number) => {
                    dispatch(setCurrentPage(page));
                }}
                totalItemsOnCurrentPage={
                    employeeNotificationsData?.data.length || 0
                }
                onItemsPerPageChange={(
                    event: React.ChangeEvent<HTMLSelectElement>,
                ) => dispatch(setItemsPerPage(Number(event.target.value)))}
                itemsPerPageSelect={itemsPerPageSelect}
            />
        </section>
    );
};
